module.exports = __webpack_public_path__ + "static/img/cloud.b60beab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/cloud.png
// module id = O5Sq
// module chunks = 215